import { render, staticRenderFns } from "./purchases_report.vue?vue&type=template&id=ed53a74c"
import script from "./purchases_report.vue?vue&type=script&lang=js"
export * from "./purchases_report.vue?vue&type=script&lang=js"
import style0 from "./purchases_report.vue?vue&type=style&index=0&id=ed53a74c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports